import React from 'react';
import { socialLinks, type SocialPlatform } from '../data/site';
import SocialIcon from './SocialIcon';

type SocialLinksProps = {
  exclude?: SocialPlatform[];
  className?: string;
  size?: 'default' | 'large';
};

function SocialLinks({ exclude = [], className = '', size = 'default' }: SocialLinksProps) {
  const links = socialLinks.filter((social) => !exclude.includes(social.platform));

  return (
    <div className={`kg-social-links kg-social-links--${size} ${className}`.trim()}>
      {links.map((social) => (
        <a
          key={social.platform}
          href={social.href}
          className="kg-social-link"
          aria-label={social.label}
          target="_blank"
          rel="noopener noreferrer"
        >
          <SocialIcon platform={social.platform} />
        </a>
      ))}
    </div>
  );
}

export default SocialLinks;
